import { LikuMotion } from '../../../store/domain/LikuMotion';
import { personaTTS, personaMotion } from '../../../data/persona';
const LikuMqtt = (mqtt, _heartbeat, getInitNum, setInitNum) => {
	const {
		publish,
		subscribe,
		// unsubscribe,
		// addHandler,
		removeHandler,
	} = mqtt;
	const heartbeat = _heartbeat;
	let uuid = null;
	let num = -1;

	const setUuid = (_uuid) => {
		uuid = _uuid;
	};

	const init = (
		uuid,
		jsonResultDone,
		setVolume,
		setLanguage,
		setMotionStatus,
	) => {
		if (num < 0) {
			num++;
			// setInitNum(num++);
			setUuid(uuid);

			subscribe(`liku/${uuid}/ackCheck`);
			subscribe(`liku/${uuid}/heartbeat`, {
				handlerFunction: heartbeat.setHeartBeat,
			});
			subscribe(`liku/${uuid}/json/result`, {
				handlerFunction: jsonResultDone,
				requiredParameter: 'both',
			});
			subscribe(`liku/${uuid}/volume`, {
				handlerFunction: setVolume,
				requiredParameter: 'payload',
			});
			subscribe(`liku/${uuid}/language/response`, {
				handlerFunction: setLanguage,
				requiredParameter: 'payload',
			});
			subscribe(`liku/${uuid}/motion-status`, {
				handlerFunction: setMotionStatus,
				requiredParameter: 'payload',
			});

			subscribe(`liku/${uuid}/volume`, {
				handlerFunction: () => heartbeat.popAck('volume'),
				requiredParameter: 'topic',
			});
			subscribe(`liku/${uuid}/language/response`, {
				handlerFunction: () => heartbeat.popAck('language'),
				requiredParameter: 'topic',
			});
			subscribe(`liku/${uuid}/motion-status`, {
				handlerFunction: () => heartbeat.popAck('motion'),
				requiredParameter: 'topic',
			});
			subscribe(`liku/${uuid}/motion-status`, {
				handlerFunction: heartbeat.setIsHeartBeat,
			});
			subscribe(`liku/${uuid}/contents`, {
				handlerFunction: (payload) => {
					console.log('왜 이동안함', payload);
					if (
						window.location.hostname.includes('torooc.net') &&
						payload &&
						payload?.contentsUuid &&
						payload?.contentsUuid !== ''
					) {
						publish(`liku/${uuid}/portal`, 'connected');
						setTimeout(() => {
							if (payload?.contentsUuid) {
								window.location.href = `/player?uuid=${payload?.contentsUuid}`;
							}
						}, 1000);
					}
				},
				requiredParameter: 'payload',
			});

			getAllStatus(true);
		}
	};

	const getAllStatus = (init = false) => {
		if (init) {
			heartbeat.setHeartBeatInterval();
		}

		getVolume();
		getLanguage();
		getMotionStatus();
	};

	const getVolume = () => {
		heartbeat.addAck('volume');
		publish(`liku/${uuid}/volume/get`, { volume: 'get' });
	};

	const getLanguage = () => {
		heartbeat.addAck('language');
		publish(`liku/${uuid}/language/get`, { language: 'data' });
	};

	const getMotionStatus = () => {
		heartbeat.addAck('motion');
		publish(`liku/${uuid}/motion-status/get`, { message: 'data' });
	};

	const setVolume = (volume) => {
		publish(`liku/${uuid}/volume/set`, { volume: `${volume}` });
	};

	/**
	 * 리쿠 언어 설정
	 * @param {string} language
	 *   - 'ko': 한국어
	 *   - 'en': 영어
	 */
	const setLanguage = (language, isPlayerHandelr) => {
		publish(`liku/${uuid}/language`, { language });

		if (isPlayerHandelr) {
			subscribe(`liku/${uuid}/language/response`, {
				handlerFunction: function (topic) {
					isPlayerHandelr(topic);
					removeHandler(`liku/${uuid}/language/response`, this.handlerFunction);
				},
				requiredParameter: 'payload',
			});
		}
	};

	const setPersona = (persona) => {
		const curPersonnaTTS = personaTTS[persona] || personaTTS.default;
		const curPersonnaMotion = personaMotion[persona] || personaMotion.default;
		const motion = new LikuMotion(curPersonnaMotion, 'eyekiss', curPersonnaTTS);
		publish(`liku/${uuid}/json/list`, motion.toPayload());

		setTimeout(() => {
			publish(`liku/${uuid}/persona`, persona);
		}, 3000);
	};

	const stop = () => {
		publish(`liku/${uuid}/user/stop`, 'stop');
	};

	const playMotion = (payload, handler) => {
		if (handler) {
			subscribe(`liku/${uuid}/json/result`, {
				handlerFunction: handler,
				requiredParameter: 'topic',
			});
		}
		publish(`liku/${uuid}/json/list`, payload);
	};

	const playExpression = (payload) => {
		publish(`liku/${uuid}/exp`, payload);
	};

	return {
		init,
		getAllStatus,
		getVolume,
		getMotionStatus,
		getLanguage,
		setVolume,
		setLanguage,
		stop,
		playMotion,
		playExpression,
		setPersona,
	};
};

export default LikuMqtt;
